import { render, staticRenderFns } from "./userDashboard.vue?vue&type=template&id=5398296c&scoped=true&"
import script from "./userDashboard.vue?vue&type=script&lang=js&"
export * from "./userDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5398296c",
  null
  
)

export default component.exports